import { Discount } from '../discount.model.js';
import { ShoppingCartRegistration } from '../../../frontend/shopping-cart/shopping-cart.interfaces.js';
import { AppliedDiscountSubscription } from './discount.interfaces.js';

/**
 * Type predicate to discriminate code from subscription. DO NOT USE IN OTHER CONTEXTS.
 * @param discount
 */
export function isDiscountCode(
  discount: Discount | AppliedDiscountSubscription | undefined | null,
): discount is Discount {
  return !!discount && Object.hasOwn(discount, 'code');
}

export function sortByDiscountAdvantage(
  discount: Discount,
  registrations: ShoppingCartRegistration[],
) {
  return registrations
    .filter(
      (registration) =>
        (isDiscountCode(registration.appliedDiscount) &&
          registration.appliedDiscount.code === discount.code) ||
        getDiscountAdvantage(discount, registration) > 0,
    )
    .sort(
      (a, b) =>
        getDiscountAdvantage(discount, b) - getDiscountAdvantage(discount, a),
    );
}

export function getDiscountAdvantage(
  discount: Discount,
  registration: ShoppingCartRegistration,
): number {
  const discountAmount = discount.calculateDiscount(
    (registration.course ?? registration.workshop).price,
  );
  if (registration.appliedDiscount) {
    const appliedDiscount = new Discount(registration.appliedDiscount);
    return (
      discountAmount -
      appliedDiscount.calculateDiscount(
        (registration.course ?? registration.workshop).price,
      )
    );
  }
  return discountAmount;
}
